import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getInsuranceCoverage } from "../../../services/api/insurance/coverage/getInsuranceCoverage";

export const QUERY_INSURANCE_COVERAGE = "QUERY_INSURANCE_COVERAGE";

export const useQueryInsuranceCoverage = (
  insuranceCoverageId: string,
  config?: WSQueryConfig<
    insuranceCoverageApiSpec.InsuranceCoverage,
    WSServiceError
  >
) =>
  useWSQuery(
    [QUERY_INSURANCE_COVERAGE, insuranceCoverageId],
    () => getInsuranceCoverage(insuranceCoverageId),
    config
  );
